import { groupByProp, sortBy } from "../../../../../helpers";

const moment = require("moment");
export const getItineraryInput = ({
  agentId,
  destinationId,
  department,
  templateItems,
  date,
  adults,
  children,
  infants,
  duration,
}) => {
  const forAdults = Number(adults) > 0;
  const forChildren = Number(children) > 0;
  const forInfants = Number(infants) > 0;
  const input = {
    adults,
    children,
    infants,
    department,
    destinationId,
    agentId,
    startDate: date,
    endDate: moment(date).add(duration, "days").toISOString(),
    participants: [{ name: "TBA", surname: "TBA" }],
    items: templateItems.map((templateItem) => {
      const adults = forAdults
        ? templateItem.serviceType == "ACCOMMODATION"
          ? parseInt(templateItem.stdOccupancy)
          : 1
        : 0;
      const children = forChildren
        ? templateItem.serviceType == "ACCOMMODATION"
          ? parseInt(templateItem.stdOccupancy)
          : 1
        : 0;
      const infants = forInfants
        ? templateItem.serviceType == "ACCOMMODATION"
          ? parseInt(templateItem.stdOccupancy)
          : 1
        : 0;
      const qty = 1;
      const itemDay = Number(templateItem.day) - 1;
      const itemStartDate = moment(date).add(itemDay, "days");
      const itemDuration =
        templateItem.serviceTypeName == "ACCOMMODATION"
          ? Number(templateItem.duration)
          : Number(templateItem.duration) - 1;

      const itemEndDate = moment(itemStartDate).add(itemDuration, "days");

      return {
        id: templateItem.uid,
        serviceId: templateItem.serviceId,
        startDate: itemStartDate,
        endDate: itemEndDate,
        adults,
        children,
        infants,
        qty,
        pricing: templateItem.customPricing
          ? {
              adultBuy: templateItem.adultBuy,
              adultSell: templateItem.adultSell,
              childBuy: templateItem.childBuy,
              childSell: templateItem.childSell,
              infantBuy: 0,
              infantSell: 0,
              itemBuy: templateItem.itemBuy,
              itemSell: templateItem.itemSell,
              currencyBuy: templateItem.currencyBuy,
              currencySell: templateItem.currencySell,
              rateTypeCode: templateItem.rateTypeCode,
            }
          : undefined,
        extras: templateItem.extras.length
          ? templateItem.extras.map((e) => {
              const extraDay = Number(e.day) - 1;
              const extraStartDate = moment(date).add(extraDay, "days");
              const extraDuration =
                templateItem.serviceType == "ACCOMMODATION"
                  ? Number(e.duration) + 1
                  : Number(e.duration);
              const extraEndDate = moment(extraStartDate).add(
                extraDuration,
                "days"
              );
              return {
                id: e.extraId,
                uid: e.extraId,
                qty: e.qty,
                startDate: extraStartDate,
                endDate: extraEndDate,
              };
            })
          : undefined,
      };
    }),
  };
  return input;
};
export const getServicesPricing = (itinerary, paxField) => {
  return itinerary.items.edges.map((item) => ({
    id: item.node.id,
    serviceName: item.node.serviceName,
    price:
      item.node.serviceTypeName == "ACCOMMODATION"
        ? Number(item.node.totalPrice) / Number(item.node.pax[paxField])
        : Number(item.node.totalPrice),
    serviceTypeName: item.node.serviceTypeName,
    stdOccupancy: Number(item.node.service.stdOccupancy),
  }));
};
export const getPaxPricing = ({ adjustments, servicesPricing }) => {
  const accommodations = getAccommodations(servicesPricing);
  return adjustments.map((a) => {
    const otherServices = getOtherServices({
      servicesPricing,
      paxFrom: a.paxFrom,
      paxTo: a.paxTo,
    });
    const totalOtherServices = otherServices.reduce(
      (sum, item) => sum + Number(item.pp),
      0
    );
    const totalFocValue = accommodations.reduce(
      (sum, acc) =>
        sum +
        ((Number(acc.pp) + Number(totalOtherServices)) *
          Number(a[`foc${acc.occupancy}`])) /
          (Number(a.paxFrom) - Number(a[`foc${acc.occupancy}`])),
      0
    );
    //console.log(totalFocValue);
    const charges = accommodations.map((acc) => {
      return {
        name: acc.name,
        pp: acc.pp + totalOtherServices,
        adjustment: Number(a[`adjustment${acc.occupancy}`]),
        total:
          Number(acc.pp) +
          totalOtherServices +
          totalFocValue +
          Number(a[`adjustment${acc.occupancy}`]),
        occupancy: acc.occupancy,
      };
    });
    return {
      minPax: a.paxFrom,
      maxPax: a.paxTo,
      charges,
    };
  });
};
export const getAccommodations = (servicesPricing) => {
  const roomTypes = {
    1: "Single",
    2: "Double/Twin",
    3: "Triple",
    4: "Quad",
  };
  const byRoomType = groupByProp(
    servicesPricing.filter((item) => item.serviceTypeName == "ACCOMMODATION"),
    "stdOccupancy"
  );
  return Object.keys(byRoomType).reduce((rooms, occupancy) => {
    rooms.push({
      name: roomTypes[occupancy],
      occupancy,
      pp: byRoomType[occupancy].reduce(
        (sum, item) => sum + Number(item.price),
        0
      ),
    });

    return rooms;
  }, []);
};
export const getOtherServices = ({ servicesPricing, paxFrom, paxTo }) => {
  return servicesPricing
    .filter((item) => item.serviceTypeName != "ACCOMMODATION")
    .map((item) => {
      const breakdown = [];
      for (let i = paxFrom; i <= paxTo; i++) {
        const qty = Math.ceil(i / Number(item.stdOccupancy));

        breakdown.push({
          pax: i,
          qty,
          pp: (qty * Number(item.price)) / i,
        });
      }

      return {
        name: `${item.serviceName}`,
        breakdown,
        pp: breakdown.sort(sortBy("pp"))[breakdown.length - 1]["pp"],
      };
    });
};



// WEBPACK FOOTER //
// ./src/components/gt/templates/builder/increments/helpers.js